document.addEventListener('DOMContentLoaded', function () {
  var phoneInput = document.getElementById('CnjOrderInfo-phone');
  if (!phoneInput) return;

  phoneInput.addEventListener('input', function (event) {
    var digits = event.target.value.replace(/\D/g, '').slice(0, 10);
    var formatted = digits;

    if (digits.length > 6) {
      formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6, 10);
    } else if (digits.length > 3) {
      formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6);
    } else if (digits.length > 0) {
      formatted = '(' + digits;
    }

    event.target.value = formatted;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var contactRadios = document.querySelectorAll('[data-cnj-contact-radio]');
  if (!contactRadios.length) return;

  var checkoutButton = document.getElementById('checkout');
  var dynamicCheckout = document.querySelector('.cart__dynamic-checkout-buttons');

  var fieldsets = [];
  contactRadios.forEach(function (radio) {
    var fieldset = radio.closest('.cnj-order-info__choice');
    if (fieldset && fieldsets.indexOf(fieldset) === -1) fieldsets.push(fieldset);
  });

  var updateContactNotices = function () {
    var anyYes = false;

    fieldsets.forEach(function (fieldset) {
      var checkedYes = fieldset.querySelector('input[value="Yes"]:checked');
      var notice = fieldset.querySelector('[data-cnj-contact-notice]');
      if (notice) notice.hidden = !checkedYes;
      if (checkedYes) anyYes = true;
    });

    if (checkoutButton) checkoutButton.disabled = anyYes;
    if (dynamicCheckout) dynamicCheckout.style.display = anyYes ? 'none' : '';
  };

  contactRadios.forEach(function (radio) {
    radio.addEventListener('change', updateContactNotices);
  });

  updateContactNotices();
});
